import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RequireAuth from './requireAuth';
import DashboardHeader from './dashboardHeader';
import { pastServicesPath, serviceEditorPath } from '../../constants';
import Card from '../../components/dashboard/card';
import { faRectangleList, faSquarePlus } from '@fortawesome/free-solid-svg-icons';

const PointsDashboard = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const mainStyle = {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.brand.linen,
        paddingTop: 'var(--nav-height)',
        minHeight: '100vh',
        boxSizing: 'border-box',
    };

    const eyebrowStyle = {
        fontFamily: theme.typography.fontFamily,
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: theme.palette.brand.brass,
        margin: '0 0 6px',
    };

    const handleNewService = () => {
        navigate(serviceEditorPath, { state: { service_key: '-1' } });
    };

    return (
        <div style={mainStyle}>
            <RequireAuth />

            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '36px 24px 56px' }}>
                <DashboardHeader eyebrow="Manage" heading="Service Points" showBackLink />

                <div style={eyebrowStyle}>Actions</div>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                        gap: '10px',
                        marginTop: '12px',
                    }}
                >
                    <div onClick={handleNewService} style={{ cursor: 'pointer' }}>
                        <Card
                            icon={faSquarePlus}
                            title="New Service"
                            description="Create a new service and add video data"
                        />
                    </div>
                    <div onClick={() => navigate(pastServicesPath)} style={{ cursor: 'pointer' }}>
                        <Card
                            icon={faRectangleList}
                            title="Past Services"
                            description="View past services, edit and delete services"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PointsDashboard;
